module.exports = __webpack_public_path__ + "img/euleros.c24abbcc.png";